import { Component, OnInit } from '@angular/core';
import { envVariables } from '@kenv';
import { DataStoreService, productDisplayName } from '@kservice';
import { Product } from '@ktypes/enums';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'kp-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
  bugUrl: string;
  feedbackUrl: string;
  showVote = envVariables.PRODUCT === Product.purposeful;
  productName = productDisplayName;

  constructor(private _dataStoreService: DataStoreService) {}

  ngOnInit() {
    this.constructUrls();
  }

  constructUrls() {
    this.feedbackUrl = `${environment.feedbackLink}?product=${productDisplayName}&platform=web&group=${encodeURI(
      this._dataStoreService.user?.group?.name
    )}`;

    this.bugUrl = `${environment.bugLink}?product=${productDisplayName}&platform=web&group=${encodeURI(
      this._dataStoreService.user?.group?.name
    )}&hardware=web&os=${encodeURI(window.navigator.platform)}&versionNumber=${encodeURI(window.navigator.userAgent)}`;

    if (this._dataStoreService.user?.group?.organization) {
      this.feedbackUrl = `${this.feedbackUrl}&org=${encodeURI(this._dataStoreService.user?.group?.organization?.name)}`;
      this.bugUrl = `${this.bugUrl}&org=${encodeURI(this._dataStoreService.user?.group?.organization?.name)}`;
    }
  }
}
